import React from 'react';
import { FaMapMarkerAlt, FaFileDownload } from "react-icons/fa";
import styles from "../../../../styles/office/EditModal.module.css";

const PropertyDetailsSection = ({ 
  language, 
  localRecord, 
  selectedRecord, 
  handleFieldChange, 
  renderReadOnlyField,
  villagePartsMap = {} // Added villagePartsMap prop
}) => {
  const certification_name_value = selectedRecord.certificatename === "Zone";
  
  // Get saved language from localStorage or use the language prop
  const savedLang = localStorage.getItem('selectedLanguage') || language || 'en';

  return (
    <div className={styles.section}>
      <h3 className={styles.sectionTitle}>
        <FaMapMarkerAlt className={styles.sectionIcon} />
        {language === 'en' ? 'Property Details' : 'मालमत्तेचे तपशील'}
      </h3>

      {renderReadOnlyField(language === 'en' ? '7/12 Extract / C.T. Survey / Gunthewari Certificate (with Old & New Survey Numbers)' : '७/१२ उतारा / मालमत्ता कार्ड',
        localRecord.attachment_pr_satbara ? (
          <a href={`${process.env.REACT_APP_SERVER_URL}/${localRecord.attachment_pr_satbara}`} download className={styles.fileLink}>
            <FaFileDownload /> {language === 'en' ? 'Download' : 'डाउनलोड'}
          </a>
        ) : <span className={styles.missingFile}>
          {language === 'en' ? 'Not Uploaded' : 'अपलोड केले नाही'}
        </span>
      )}



      {renderReadOnlyField(language === 'en' ? 'Measurement Sheet / C.T. Survey Map / Layout / Gunthewari Plot Map' : 'मापन पत्रक',
        localRecord.meausurementAttachment ? (
          <a href={`${process.env.REACT_APP_SERVER_URL}/${localRecord.meausurementAttachment}`} download className={styles.fileLink}>
            <FaFileDownload /> {language === 'en' ? 'Download' : 'डाउनलोड'}
          </a>
        ) : <span className={styles.missingFile}>
          {language === 'en' ? 'Not Uploaded' : 'अपलोड केले नाही'}
        </span>
      )}

      {/* {!certification_name_value && (
       
      renderReadOnlyField(language === 'en' ? 'Measurement Sheet / C.T. Survey Map / Layout / Gunthewari Plot Map' : 'मापन पत्रक',
        localRecord.meausurementAttachment ? (
          <a href={`${process.env.REACT_APP_SERVER_URL}/${localRecord.meausurementAttachment}`} download className={styles.fileLink}>
            <FaFileDownload /> {language === 'en' ? 'Download' : 'डाउनलोड'}
          </a>
        ) : <span className={styles.missingFile}>
          {language === 'en' ? 'Not Uploaded' : 'अपलोड केले नाही'}
        </span>
      )


      )} */}

      

      {/* Village Dropdown - Replaced the read-only field */}
      <div className={styles.formGroup}>
        <label>
          {savedLang === "mr" ? "गाव" : "Village"} <span className={styles.required}>*</span>
        </label>
        <select
          name="village"
          value={localRecord.village || ''}
          onChange={(e) => {
            handleFieldChange('village', e.target.value);
            // Reset villagePart when village changes
            handleFieldChange('villagePart', '');

             console.log(e.target.value);

             console.log("localRecord : ",localRecord);

          }}
          className={styles.editableInput}
          required
        >
          <option value="">
            {savedLang === "mr" ? "गाव निवडा" : "Select Village"}
          </option>
          {Object.keys(villagePartsMap).map((village) => (
            <option key={village} value={village}>
              {village}
            </option>
          ))}
        </select>
      </div>

      {renderReadOnlyField(language === 'en' ? 'Property Number Type' : 'गाव', localRecord.PropertyNumberType)}
      {renderReadOnlyField(language === 'en' ? 'CTS / Gat / Survey No. / TPS No. / Area Name' : 'सर्व्हे नंबर', localRecord.surveyNumber)}

      {renderReadOnlyField(language === 'en' ? 'Village Area' : 'गाव', localRecord.usageDepartment)}

      {/* {certification_name_value && (
        <div className={styles.formGroup}>
          <label>{language === 'en' ? 'Zone Statement' : 'शेरा'}</label>
          <input
            type="text"
            value={localRecord.zoneStatementValue || ''}
            onChange={(e) => { handleFieldChange('zoneStatementValue', e.target.value); }}
            className={styles.editableInput}
            required
          />
        </div>
      )} */}
    </div>
  );
};

export default PropertyDetailsSection;